module.exports = __webpack_public_path__ + "img/act1.9bca70c8.jpg";